import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface User {
  id: string
  username?: string
  email: string
  firstName: string
  lastName: string
  role: string
  tenantId: string
  departmentId?: string
}

export interface AuthState {
  user: User | null
  token: string | null
  isAuthenticated: boolean
  isLoading: boolean
  error: string | null
}

// Initialize state from localStorage
const storedToken = localStorage.getItem('authToken')
const storedUser = localStorage.getItem('user')
let initialUser: User | null = null

if (storedUser) {
  try {
    initialUser = JSON.parse(storedUser)
  } catch (error) {
    console.error('Error parsing stored user data:', error)
    localStorage.removeItem('user')
    localStorage.removeItem('authToken')
  }
}

const initialState: AuthState = {
  user: initialUser,
  token: storedToken,
  isAuthenticated: !!(storedToken && initialUser),
  isLoading: false,
  error: null,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.isLoading = true
      state.error = null
    },
    loginSuccess: (state, action: PayloadAction<{ user: User; token: string }>) => {
      state.isLoading = false
      state.user = action.payload.user
      state.token = action.payload.token
      state.isAuthenticated = true
      state.error = null
      localStorage.setItem('authToken', action.payload.token)
      localStorage.setItem('user', JSON.stringify(action.payload.user))
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.isLoading = false
      state.error = action.payload
      state.isAuthenticated = false
    },
    logout: (state) => {
      state.user = null
      state.token = null
      state.isAuthenticated = false
      state.error = null
      localStorage.removeItem('authToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('user')
    },
    clearError: (state) => {
      state.error = null
    },
  },
})

export const { loginStart, loginSuccess, loginFailure, logout, clearError } = authSlice.actions
export default authSlice.reducer